import useTableService from "@/components/useTableServerSide";
import React, { useState, useEffect, useRef } from "react";
import logoac from "@/imagenes/lg_vehiculo.png";
import { SearchInput } from "@/ui/inputs/Input";
import Footer from "@/components/Footer";
import { Dimmer } from "@/components/spinner";
import { Mensaje } from "@/components/mensajes2";
import axios from "axios";
import { AgregarVehiculos } from "./modalRegistrarVehiculos2";
import { Toasts } from "@/components/toasts";
import { PrimaryButton } from "@/ui/buttons/Button";

export default function TablaVehiculos(props) {
  const permiso = JSON.parse(localStorage.getItem("accvehiculo"));
  const token = localStorage.getItem("jwtToken");
  const op = require("@/modulos/datos");
  const searchTimeoutRef = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectItem, setSelectItem] = useState({
    ope: 1,
    item: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [totales, setTotales] = useState({
    activos: 0,
    inactivos: 0,
    total: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const headCells = [
    {
      id: "idvehiculo",
      label: "CÓDIGO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "placa",
      label: "PLACA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "ritm",
      label: "RITM",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRE",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
  ];
  const cardsData = [
    {
      title: "Vehiculos Registrados",
      value: totales.total,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () =>
        imprimirReporte(" status in(0,1) ", "Lista de Vehiculos Registrados"),
    },
    {
      title: "Vehiculos Activos",
      value: totales.activos,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () =>
        imprimirReporte(" status = 0 ", "Lista de Vehiculos Activos"),
    },
    {
      title: "Vehiculos Inactivos",
      value: totales.inactivos,
      color: "#4e80b1",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () =>
        imprimirReporte(" status = 1 ", "Lista de Vehiculos Inactivos"),
    },
  ];
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const buscarRegistros = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
    };
    const endpoint = `${op.conexion}/api/vehiculo/gestion-contribuyentes`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
          setTotales(response.data.totales);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const seleccionarRegistro = (item, ope, per) => {
    try {
      if (per.toString() !== "1") {
        const mensaje =
          ope === 1
            ? "No posee permiso para Registrar"
            : ope === 2
              ? "No posee permiso para Editar"
              : ope === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar";
        setToast({
          mostrar: true,
          mensaje: mensaje,
          titulo: "Alerta.",
        });
        return;
      }
      setSelectItem({
        ope: ope,
        item: item,
      });
      setMostrarModal(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Seleccionar el Registros",
        icono: "error",
      });
    }
  };
  const imprimirReporte = (sql, titulo) => {
    try {
      window.open(
        op.reportes +
          "/impuestovehiculo?" +
          "reporte=ListVehiculos" +
          "&sql=" +
          sql +
          "&sql3= and " +
          sql +
          "&sql2=" +
          titulo,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Imprimir el Reporte",
        icono: "error",
      });
    }
  };
  useEffect(() => {
    buscarRegistros();
  }, [tableState]);
  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-4 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-6 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              {/* Círculo decorativo */}
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
                {card.print && (
                  <div
                    className="mt-2"
                    style={{ position: "relative", zIndex: 10 }}
                  >
                    <button
                      onClick={card.print}
                      className="btn btn-sm btn-light rounded-circle p-2"
                      style={{ width: "35px", height: "35px" }}
                    >
                      <i className="fas fa-print"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-8">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white">
              <h5 className="mb-0 fw-bold">
                Gestión de Impuestos de Vehiculos
              </h5>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
                <PrimaryButton
                  icon="fa-plus m-0"
                  onClick={() => {
                    seleccionarRegistro(
                      "",
                      1,
                      permiso.toString().substring(1, 2),
                    );
                  }}
                  disabled={permiso.toString().substring(1, 2) !== "1"}
                />
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "70px" }}
                          >
                            {item.idvehiculo}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "70px" }}
                          >
                            {item.placa}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "70px" }}
                          >
                            {item.ritm}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "left", width: "auto" }}
                          >
                            {item.nombrepropie}
                          </td>

                          <td
                            className="align-baseline"
                            align="center"
                            style={{ textAlign: "center", width: "120px" }}
                          >
                            <button
                              onClick={() => {
                                seleccionarRegistro(
                                  item,
                                  4,
                                  permiso.toString().substring(0, 1),
                                );
                              }}
                              className={
                                permiso.toString().substring(0, 1) === "1"
                                  ? "btn btn-sm btn-info rounded-circle mx-1"
                                  : "btn btn-sm btn-secondary rounded-circle mx-1"
                              }
                            >
                              <i className="fas fa-eye"></i>{" "}
                            </button>
                            <button
                              onClick={() => {
                                seleccionarRegistro(
                                  item,
                                  2,
                                  permiso.toString().substring(2, 3),
                                );
                              }}
                              className={
                                permiso.toString().substring(2, 3) === "1"
                                  ? "btn btn-sm btn-warning rounded-circle mx-1"
                                  : "btn btn-sm btn-secondary rounded-circle mx-1"
                              }
                            >
                              <i className="fas fa-edit"></i>{" "}
                            </button>
                            <button
                              onClick={() => {
                                seleccionarRegistro(
                                  item,
                                  3,
                                  permiso.toString().substring(3, 4),
                                );
                              }}
                              className={
                                permiso.toString().substring(3, 4) === "1"
                                  ? "btn btn-sm btn-danger rounded-circle mx-1"
                                  : "btn btn-sm btn-secondary rounded-circle mx-1"
                              }
                            >
                              <i className="fa fa-trash-alt"></i>{" "}
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div
            className="card shadow-1-strong d-flex align-items-center justify-content-center"
            style={{ borderRadius: "15px", minHeight: "500px" }}
          >
            <div className="text-center p-4">
              <img
                src={logoac}
                alt="Dashboard Illustration"
                className="img-fluid"
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <AgregarVehiculos
        show={mostrarModal}
        onHide={() => {
          (setMostrarModal(false), buscarRegistros());
        }}
        idVehiculo={selectItem.item?.idvehiculo}
        operacion={selectItem?.ope}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={() =>
          setToast({
            ...toast,
            mostrar: false,
          })
        }
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
